<template>
  <page-outline>
    <template slot="pageContent">
      <div :class="['content bg-light',{ expanded: !isSidebarOpen }]">
        <div>
          <!-- title -->
          <b-container fluid>
            <div class="content-title">
              <b-row>
                <h1>User Management</h1>
              </b-row>
              <b-row>
                <span>Manage user accounts and permissions</span>
              </b-row>
            </div>

            <!-- data -->
            <b-row class="stats">
              <b-col @click="stat.status != null ? selectStatus(stat.status): ''" v-for="(stat, index) in stats" v-bind:key="index">
                <div>
                  <span :style="{color: stat.color}">{{ stat.number }}</span>
                  <span>{{ stat.title }}</span>
                </div>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>
    </template>
  </page-outline>
</template>

<script>
import PageOutline from '@/components/common/PageOutline.vue'

export default {
  name: 'UserManagementPage',
  components: {
    'page-outline': PageOutline
  },
  data () {
    return {
      isSidebarOpen: true,
      stats: [
        {
          "title":"Total Users",
          "number": 0,
          "color": "#2b7fff",
          "status": "all"
        },
        {
          "title":"Active Users",
          "number": 0,
          "color": "#009966",
          "status": 'active'
        },
        {
          "title":"Admin",
          "number": 0,
          "color": "#e7000b",
          "status": 'admin'
        },

        {
          "title":"Specialists",
          "number": 0,
          "color": "#9810fa",
          "status": 'specialists'
        }
      ],
    }
  },
  methods: {
  }
}
</script>
<style scoped>

  .content-title{
    margin: 1.5rem 0rem;
  }


  .content-title>div>span{
    color: #000000a6;
    font-size: 1.1rem;
  }

  .stats>div{
  display: flex;
}

.stats{
  display: flex;
  gap: 1rem;
  padding: 1rem 0rem;
}


.stats>div{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 8rem;
  background-color: #fff;
  border: 1px solid #0000001a;
  border-radius: calc(1rem - 2px);
  padding: 0rem 1rem;
}

.stats>div:hover{
  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  cursor: pointer;
}

.stats>div>div{
  display: grid;
  row-gap: 1.5rem;
  color: #000000a6;
}

.stats>div>div>span:last-of-type{
  font-size: 1rem;
}

.stats>div>div>span{
  font-size: 2rem;
  display: flex;
  justify-content: center;
}
</style>

